<div class="modal-container">
    <div class="modal-header">
        <h4 class="mb-0">{{localize(langSection.DeliveryTypeModal, langText.DeliveryTypeHeader)}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
    </div>
    <div class="modal-sub-header">
        <em>{{localize(langSection.DeliveryTypeModal, langText.DeliveryTypeSubText)}}</em>
    </div>
    <div class="modal-body">
        <div class="emails">
            @for (emailPair of emailPairs; track emailTrackBy(i, emailPair); let i = $index) {
<div class="labeled-input">
                <label>{{localize(langSection.Term, langText.Email)}} {{i > 0 ? i + 1 : ''}}</label>
                <div class="d-flex align-items-center position-relative">
                    <input type="text" class="form-control email-input me-2" [class.error]="!emailPair.valid"
                        (input)="validateEmail($event.target.value, i)" [value]="emailPair.email">
                    @if (!emailPair.valid) {
<span class="error-icon"></span>
}
                    <span role="button" class="ups-icon ups-icon-trash-can" (click)="onRemoveEmailClick(i)"></span>
                </div>
                @if (!emailPair.valid) {
<span class="error-message">{{localize(langSection.DeliveryTypeModal, langText.EmailInvalid)}}</span>
}
            </div>
}
            @if (emailPairs.length < maxEmailCount && allEmailsHaveValue && allEmailsValid) {
<div class="add-email-btn" role="button" (click)="onAddEmailClick()">
                <span class="ups-icon ups-icon-plus-circle"></span>
                <span>{{localize(langSection.NotificationSettings, langText.AddAnotherEmail)}}</span>
            </div>
}
        </div>
    </div>
    <div class="modal-footer">
        @if (saveFailed) {
<span class="error-message mt-0">{{localize(langSection.DeliveryTypeModal, langText.SaveFailed)}}</span>
}
        <button class="btn btn-green" [disabled]="!canSubmit" (click)="submit()">{{localize(langSection.HomePage, langText.Apply)}}</button>
    </div>
</div>